var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiggestbookProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.biggestbook{fill:url(#biggestbook-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "biggestbook-gradient",
    x1: 19.56772,
    y1: 18.46775,
    x2: 82.53269,
    y2: 83.70856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79b5ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#448fa8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#375d72"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "biggestbook",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M45.89392,30.95114h-18.5488c-1.35766,0-2.45827,1.1006-2.45827,2.45827v30.52829c0,1.35766,1.1006,2.45827,2.45827,2.45827h14.51437c2.46336,0,4.77821.98164,6.4927,2.65248v-35.63905c0-1.35766-1.1006-2.45827-2.45827-2.45827Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M51.64748,33.40941v35.63945c1.71455-1.67111,4.02955-2.65289,6.4931-2.65289h14.5143c1.35766,0,2.45827-1.1006,2.45827-2.45827v-30.52829c0-1.35766-1.1006-2.45827-2.45827-2.45827h-18.54914c-1.35766,0-2.45827,1.1006-2.45827,2.45827Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiggestbookProductsScraper);
export default __webpack_public_path__ + "static/media/biggestbook-products-scraper.9dd4db7d27d5b8afd5ae97ce5bcaf320.svg";
export { ForwardRef as ReactComponent };